export default __webpack_public_path__ + "static/media/learose3-1440w.22d12d4e.png";